module.exports = __webpack_public_path__ + "static/img/background_intro.916f65b.png";